// src/utils.js
// Utility functions for Engryv site

export function isDev() {
  return window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
}

/**
 * Escape HTML special characters to prevent XSS injection attacks
 * Use this when inserting user-provided or untrusted data into innerHTML
 * 
 * @param {string|null|undefined} str - String to escape
 * @returns {string} Escaped string safe for HTML contexts, or empty string if null/undefined
 * @example
 * // Safe to use in innerHTML
 * element.innerHTML = `<h1>${escapeHTML(userInput)}</h1>`
 * 
 * // Use textContent instead when possible (auto-escaped)
 * element.textContent = userInput // Already safe
 */
export function escapeHTML(str) {
    if (str === null || str === undefined) return '';
    return str.toString()
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
}
